import React from "react";
import "./AlphabetNav.scss";

const ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZ#".split("");

const AlphabetNav = ({ availableLetters, onLetterClick }) => {
  const handleClick = (letter) => {
    onLetterClick(letter);
  };

  return (
    <nav className="alphabet-nav">
      {ALPHABET.map((letter) => {
        const isAvailable = availableLetters.has(letter);
        return (
          <button
            key={letter}
            className={`alphabet-nav-letter ${isAvailable ? "available" : "disabled"}`}
            onClick={() => isAvailable && handleClick(letter)}
            disabled={!isAvailable}
            aria-label={`Jump to ${letter}`}
          >
            {letter}
          </button>
        );
      })}
    </nav>
  );
};

export default AlphabetNav;
